// src/components/HeaderComp.js
import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmDialog from '../ConfirmDialog';
import { LogoutApp } from '../../redux/actions/authActions';
import logo from '../../utils/images/logo.png';
import './Styles.scss';

const HeaderComp = ({ toggleSidebar  }) => {
  const dispatch = useDispatch();
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const { user} = useSelector((state) => state.auth);
  const handleLogout = () => {
    // Open the confirmation dialog
    setConfirmDialogOpen(true);
  };
  const handleConfirmLogout = () => {
    // Add your logout logic here
    console.log('User logged out');
    dispatch(LogoutApp());
    setConfirmDialogOpen(false);

  };

  const handleCancelLogout = () => {
    setConfirmDialogOpen(false);
  };
  return (
    <AppBar position="fixed">
      <Toolbar className='headItems'>
      <div className='toolBar'>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={toggleSidebar}
        >
          <MenuIcon />
        </IconButton>
        <img src={logo} alt='' className='head-logo-img'/>
        </div>
        <div className='headAvatar'>
          <Avatar alt="User"/>
          <Button color="inherit" onClick={handleLogout}>Logout</Button>
        </div>
      </Toolbar>
      <ConfirmDialog
        open={confirmDialogOpen}
        title="Confirm Logout"
        message="Are you sure you want to logout?"
        onConfirm={handleConfirmLogout}
        onCancel={handleCancelLogout}
      />
    </AppBar>
    
  );
};

export default HeaderComp;
